import { z } from 'zod';

/**
 * `company` is a honeypot: a field real users never see or fill (hidden via
 * CSS on the marketing site's form) but bots that auto-fill every input will.
 * A non-empty value here makes the service silently no-op instead of erroring,
 * so it doesn't tip off the bot that it was caught.
 */
export const marketingContactFormSchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email(),
  message: z.string().min(1).max(5000),
  company: z.string().optional().default(''),
});
export type MarketingContactFormInput = z.infer<typeof marketingContactFormSchema>;
